import { Route, Routes } from 'react-router-dom';
import './App.scss';
import Layout from './hoc/layout/layout';
import Dashboard from './features/dashboard/dashboardContainer';
import ImageContainer from './features/chartImages/container/imagesContainer';
import MaterialChart from './features/materialChart/marterialChart';

function App() {
	return (
		<Layout>
			<Routes>
				<Route path='/' element={<Dashboard />} />
				<Route path='/images/:token/:id/:language/:decimalSeparator/:isForeCastInclude' element={<ImageContainer />} />
				<Route path='/material/chart' element={<MaterialChart />} />
			</Routes>
		</Layout>
	);
}

export default App;
